import { useEffect, useRef } from "react"
import { leaveTarget } from "@/lib/orderLeave"

/**
 * Hỏi trước khi rời trang đang nhập dở: bắt cú bấm vào liên kết trong app (thanh tab, menu, "Quay lại"…)
 * ở pha capture — trước khi <Link> của react-router kịp đổi trang — rồi giao đường dẫn đích cho onLeave.
 * App dùng <BrowserRouter> nên không có useBlocker; nút Back / vuốt lùi của trình duyệt không chặn được.
 */
export function useLeaveGuard(active: boolean, onLeave: (to: string) => void) {
  const onLeaveRef = useRef(onLeave)
  onLeaveRef.current = onLeave
  useEffect(() => {
    if (!active) return
    const onClick = (e: MouseEvent) => {
      const to = leaveTarget(e, window.location)
      if (to == null) return
      e.preventDefault()
      e.stopPropagation()
      onLeaveRef.current(to)
    }
    document.addEventListener("click", onClick, true)
    return () => document.removeEventListener("click", onClick, true)
  }, [active])
}
